import {
    EDIT_EMPLOYMENT_ITEM
} from "./Actions/user";

import {
    API_,
    CRM_API_,
    SERVER_,
    NODE_API_,
    CRM_URL_,
    FILE_BASE_URL_,
    FILE_MAKER_SERVER_BASE_URL_
} from "./app_url";

export const CONFIRM_VERIFY_PROJECT_URL = '/project/confirm/verify';
export const CONFIRM_VERIFY_EMPLOYMENT_URL = '/employment/confirm/verify';
export const EDIT_SKILL_URL = '/profile/skill/edit';
export const ALLOW_TOBE_MEMBER_URL = '/project/grant/permission';
export const ACCEPT_ONLY_PROJECT_URL = "/project/grant/without/permission";
export const ACCEPT_ONLY_EMPLOYMENT_URL = "/employment/grant/without/permission";
export const ALLOW_TOBE_EMPLOYMENT_MEMBER_URL = '/employment/grant/permission';
export const REQUEST_TO_VIEW_PROFILE_URL = '/notification/request/profile'
export const GRANT_REQUEST_TO_VIEW_PROFILE_URL = '/notification/request/profile/grant'
export const CHECK_REQUEST_TO_VIEW_PROFILE_URL = '/notification/check/profile/permission'
export const RESET_NOTIFICATION_URL = '/notification/set-all-read';
export const GET_NOTIFICATION_DATA_URL = '/notification/view';
export const DECLINE_TOBE_MEMBER_URL = '/project/decline/permission';
export const EDIT_PROJECT_MEMBERS_URL = '/project/edit-members';



export const API = API_;
export const SITE_API = API_;
export const CRM_API = CRM_API_;
export const SOCKET = SERVER_;
export const NODE_API = NODE_API_;
export const FILE_MAKER_SERVER_BASE_URL = FILE_MAKER_SERVER_BASE_URL_;

const debug = process.env.NODE_ENV !== "production";

// get browser host url
const getHostUrl = () => {
    let host = window.location.host;
    return host;
}

const isLocalHost = getHostUrl().startsWith("localhost");


export const CRM_URL = debug ? isLocalHost ? "http://localhost:8081/" : "https://fe2b-41-186-50-227.in.ngrok.io/" : CRM_URL_;
export const FILE_BASE_URL = FILE_BASE_URL_;

export const ACCOUNT_TYPE = "student";

export const API_BASE_URL = API;

export const GET_ALL_FEEDS_REQUEST = "/feed/all";
export const GET_LOCALE_REQUEST = "/locale/get";
//It uses post method. It also requires data body: group,locale

export const AUTH_LOGIN_URL = "/auth/login";
export const AUTH_SET_TYPE_URL = "/account/save/type"
//It requires data body: password,email
export const AUTH_LOGOUT_URL = "/auth/logout";

export const AUTH_LINKEDIN_SIGNUP_URL = "/account/student/signup";
export const AUTH_GOOGLE_SIGNUP_REQUEST_URL = "/account/student/signup/google";
export const AUTH_FACEBOOK_SIGNUP_REQUEST_URL = "/account/student/signup/facebook";
export const AUTH_MICROSOFT_SIGNUP_REQUEST_URL = "/account/student/signup/microsoft";
export const NOTIFICATION_GET_NODE_VAPID_URL = "/notification/get/vapid";
export const NOTIFICATION_SAVE_USER_CHANNELS_URL = "/notification/submit/channel";
export const CONSULTIFIED_SIGNUP_URL = "/account/register"
export const STAFF_CONSULTIFIED_SIGNUP_URL = "/account/staff/register" // NEW
export const ACCOUNT_FINISH_WIZARD_URL = "/profile/wizard/finish";
export const ACCOUNT_REGISTER_VIA_INVITE_URL = "/account/get-data";
export const AUTH_LINKEDIN_LOGIN_URL = "/auth/linkedin";
export const VERIFY_ACCOUNT_URL = "/account/activate";
export const RESEND_VERIFY_EMAIL_ACCOUNT_URL = "/account/resent-email";
export const GET_CRM_TOKEN_URL = "/auth/login-by-id";
export const SUBMIT_SETTING_URL = "/account/settings/save";
export const GET_SUBMIT_SETTING_URL = "/account/settings/get";
export const FORGOT_PASSWORD_URL = "/account/reset";
export const CREATE_PASSWORD_URL = "/account/create-password";

export const GET_ME_PROFILE_DATA_URL = "/profile/me";
export const GET_ME_PROFILE_URL = "/profile/get-profile";
export const TITLE_BAR_INFO_URL = "/profile/toolbar-info";
export const GET_TRANSLATIONS_URL = "/locale/get"

export const GET_COUNTRIES_URL = "/data/countries/list"
export const GET_CITIES_URL = "/data/cities/list"
export const GET_COMPANIES_URL = "/data/companies/list"

//start of feeds routes
export const REMOVE_FEED_COMMENT_URL = "/feed/delete/comment"
export const GET_PROFILE_FEEDS_URL = "/data/profile/card";
export const GET_FEEDS_POSTS_URL = "/feed/all/";
export const POST_FEED_POST_URL = "/feed/create";
export const TAG_FEED_POST_URL = "/feed/tags";
export const GET_MORE_FEEDS_POSTS_URL = ""; //TODO:here the url is incomplete
export const POST_FEED_COMMENT_URL = "/feed/comment/create";
export const POST_FEED_LIKE_URL = "/feed/like";
export const DELETE_FEED_POST_URL = "/feed/delete";
export const EDIT_POST_URL = "/feed/edit";
export const FEED_SEARCH_INTERNSHIP_TAGS_URL = "/feed/search/internship/tags";
export const FEED_INTERNSHIP_FILTER_BY_TAGS_URL = "/feed/internship/filter/by/tags"
export const FEED_INTERNSHIP_FILTER_BY_LOCATION_URL = "/feed/internship/filter/by/location";
export const FEED_INTERNSHIP_FILTER_BY_WORKTYPE_URL = "/feed/internship/filter/by/worktype";
export const FEED_INTERNSHIP_FILTER_BY_STATUS_URL = "/feed/internship/filter/by/status";
export const FEED_INTERNSHIP_FILTER_BY_CLASS_URL = "/feed/internship/filter/by/class"

//end of feeds routes

//start of messages routes
export const GET_CHAT_CONNECTIONS_URL = "/messages/message-connections"; // remove
export const SEARCH_NEW_CONNECTIONS_URL = "/messages/search/new/connections";
export const SEARCH_CONNECTIONS_URL = "/messages/search/connections";
export const GET_CHAT_MESSAGES_URL = "/messages/get-message";
export const SET_AS_READ_URL = "/messages/set-read";
export const POST_MESSAGE_URL = "/messages/send";
export const POST_SEARCH_CONNECTION_URL = "/messages/get-search-queries"
export const POST_SEARCH_CONSULTANTS_URL = "/messages/get-search-queries"
export const POST_SEARCH_TAGS_URL = "/feed/search/tags"
export const MESSAGE_CONVERSATION_URL = "/messages/message-connections";
export const MESSAGE_GET_CHAT_URL = "/messages/get-message";
export const MESSAGE_SEND_SMS_URL = "/messages/send";
export const MESSAGE_SEARCH_CONVERSATION_URL = "/messages/search/connections";
export const MESSAGE_SEARCH_SMS_URL = "/messages/search/sms";
export const MESSAGE_SEARCH_CONTACT_URL = "/messages/search/new/connections";
//end of messages routes


//add profile routes




export const ADD_EXPERIENCE_URL = "/profile/add/experience";
export const ADD_PORTFOLIO_URL = "/profile/add/portfolio";
export const ADD_EMPLOYMENT_URL = "/profile/add/employment";
export const ADD_QUALIFICATION_URL = "/profile/add/training";
export const ADD_EDUCATION_URL = "/profile/add/education";


export const UPDATE_EXPERIENCE_URL = "/profile/edit/experience";
export const UPDATE_PORTFOLIO_URL = "/profile/edit/portfolio";
export const UPDATE_EMPLOYMENT_URL = "/profile/edit/employment";
export const UPDATE_QUALIFICATION_URL = "/profile/edit/qualification";
export const UPDATE_EDUCATION_URL = "/profile/edit/education";


export const DELETE_EXPERIENCE_URL = "/profile/delete/experience";
export const DELETE_PORTFOLIO_URL = "/profile/delete/portfolio";
export const DELETE_QUALIFICATION_URL = "/profile/delete/qualification";
export const DELETE_EDUCATION_URL = "/profile/delete/education";



export const VIEW_EDUCATION_URL = "/profile/get/education"

export const VIEW_EXPERIENCE_URL = "/profile/get/experience";
export const VIEW_PORTFOLIO_URL = "/profile/get/portfolio";
export const VIEW_EMPLOYMENT_URL = "/profile/get/employment";
export const VIEW_QUALIFICATION_URL = "/profile/get/qualification";
export const DELETE_SKILL_URL = "/profile/skill/delete";



export const ADD_COMPANY_URL = "/company/create";
export const GET_COMPANY_INFO_URL = "/company/get-info";
export const GET_COMPANY_INFO_ADMIN_URL = "/company/admin/get-info";
export const BUY_COMPANY_URL = "/company/buy";
export const ADD_EMPLOYEE_URL = "/company/add-employee";
export const GET_COMPANY_EMPLOYEES_URL = "/company/get-employees";
export const EDIT_PROFILE_INFO_URL = "/profile/update/info";
export const CHANGE_PASSWORD_URL = "/profile/update/password";
export const DELETE_ACCOUNT_URL = "/profile/account/delete";


export const SAVE_PROJECT_URL = "/project/create";
export const DELETE_PROJECT_URL = "/project/delete";
export const DELETE_EMPLOYMENT_URL = "/employment/delete";
export const VERIFY_PROJECT_URL = "/project/verify";
export const VERIFY_EMPLOYMENT_URL = "/employment/verify";
export const ADD_SKILL_URL = "/project/skill/add";
export const EDIT_PROJECT_ITEM_URL = "/project/edit/item";
export const EDIT_EMPLOYMENT_ITEM_URL = "/employment/edit/item";
export const EDIT_QUALIFICATION_ITEM_URL = "/profile/edit/qualification";
export const SAVE_EMPLOYMENT_URL = "/employment/create";
export const SEARCH_FOR_PROJECT_MEMBERS_URL = "/project/search-members";
export const GET_ME_DASHBOARD_DATA_URL = "/profile/get/dashboard";
export const INVITE_USER_VIA_PROJECT_URL = "/invitation/project"
export const INVITE_USER_VIA_EMAIL_URL = "/invitation/invite"
export const SUBMIT_INVITE_PARTICIPATION_INFO_URL = "/account/invite-participation-info"
export const SEND_CONTACT_MAIL_URL = "/send-contact-email"
export const SEND_INVESTOR_MAIL_URL = "/send-investor-email"
export const EXPORT_CV_URL = "/profile/export"
export const GRANT_PERMISSION_URL = "grant/permission";
export const SAVE_CERTIFICATION_URL = "/profile/add/certification"
export const DELETE_QUALIFICATION_ITEM_URL = "/profile/delete/qualification"
export const SEARCH_INDEX_URL = "/search/index"
export const SEARCH_BY_LOCATION_URL = "/search/by/location"
export const SEARCH_BY_SKILLS_URL = "/search/by/skills"
export const SEARCH_BY_COMPANY_URL = "/search/by/company"
export const SEARCH_BY_ALL_URL = '/search/by/all'
export const EMPLOYMENT_SET_AS_CURRENT_URL = "/employment/set/current"
export const ADD_NEW_CONSULTANT_INFO_URL = "/consultant/set/information";


// Customer  api
export const ADD_NEW_CUSTOMER_URL = "/customer/setup/wizard";
export const GET_CUSTOMER_URL = "/customer/get-info";
export const UPDATE_CUSTOMER_URL = "/customer/update/info";
export const SEARCH_ON_CUSTOMER_URL = "/customer/search";
export const GET_ASSIGNMENT_URL = "/customer/get/leads";
export const DELETE_ASSIGNMENT_URL = "/customer/delete/lead";
export const PUBLISH_ASSIGNMENT_URL = "/customer/publish/lead";
export const UNPUBLISH_ASSIGNMENT_URL = "/customer/unpublish/lead";
export const GET_ALL_ASSIGNMENT_URL = "/customer/get/all/leads";
export const ADD_NEW_ASSIGNMENT_URL = "/customer/create/leads"
export const UPDATE_ASSIGNMENT_URL = "/customer/update/lead"
export const GET_CUSTOMER_BY_ID_URL = "/customer/user/get-info";
export const GET_ASSIGNMENT_BY_CUSTOMER_ID_URL = "/customer/get/user/leads";
export const SEARCH_ASSIGNMENT_URL = "/assignment/search";
export const DELETE_CUSTOMER_ACCOUNT_URL = "/customer/delete";
export const UPDATE_CUSTOMER_ACCOUNT_PASSWORD_URL = "/accounts/change-password";


// Skills component api
export const GET_SKILLS_URL = "/search/skill/suggestions";
export const SEARCH_SKILLS_URL = "/search/skill/suggestions";
export const SKILL_SAVE_PRIOLITY_URL = "/profile/skill/priority";

// Company api
export const ADD_COMPANY_MANAGER_INFO_URL = "/company/wizard";
export const GET_ME_USER_COMPANY_URL = "/company/get-info";
export const DELETE_COMPANY_ACCOUNT_URL = "/company/manager/delete";
export const DELETE_COMPANY_URL = "/company/delete";
export const UPDATE_COMPANY_ACCOUNT_PASSWORD_URL = "/accounts/change-password";
export const UPDATE_COMPANY_INFO_URL = "/company/update-info";
export const UPDATE_MANAGER_INFO_URL = "/company/update-manager-info";
export const ADD_COMPANY_MEMBER_URL = "/company/add-members";
export const GRANT_TO_BE_COMPANY_MEMBER_URL = "/company/confirm-add-employee";
export const ADD_PITCH_URL = "/company/create-pitch";
export const SEARCH_FOR_COMPANY_MEMBERS_URL = "/company/search-members";
export const REMOVE_PITCH_URL = "/company/remove-pitch";
export const UPDATE_PITCH_URL = "/company/update-pitch";
export const SEARCH_PITCH_URL = "/company/search-pitch";
export const REMOVE_MEMBER_FROM_PITCH_URL = "/company/remove-pitch-member";
export const REMOVE_MEMBER_FROM_COMPANY_URL = "/company/remove-member";
export const SEARCH_COMPANY_PROJECT_URL = "/company/search-projects";

// Company consultant profile api
export const GET_CONSULTANT_ALL_DATA_URL = "/company/consultant/get-info";
export const EXPORT_CONSULTANT_CV_URL = "/company/consultant/export-cv";
export const SAVE_CONSULTANT_INFO_URL = "/company/consultant/save-info";
export const COMPANY_CONSULTANT_UPDATE_PROJECT_URL = "/company/project/update";
export const COMPANY_CONSULTANT_ADD_NEW_PROJECT_URL = "/company/project/create";
export const COMPANY_CONSULTANT_DELETE_PROJECT_URL = "/company/project/delete";
export const COMPANY_CONSULTANT_VERIFY_PROJECT_URL = "/company/project/verify";
export const COMPANY_CONSULTANT_ADD_SKILL_URL = "/company/project/skill/add";
export const COMPANY_CONSULTANT_DELETE_SKILL_URL = "/company/consultant/skill/delete";
export const COMPANY_CONSULTANT_UPDATE_SKILL_URL = "/company/consultant/skill/update";
export const COMPANY_CONSULTANT_SAVE_SKILL_PRIOLITY_URL = "/company/consultant/skill/priority";
export const COMPANY_CONSULTANT_UPDATE_EMPLOYMENT_URL = "/company/employment/update";
export const COMPANY_CONSULTANT_ADD_NEW_EMPLOYMENT_URL = "/company/employment/create";
export const COMPANY_CONSULTANT_DELETE_EMPLOYMENT_URL = "/company/employment/delete"
export const COMPANY_CONSULTANT_VERIFY_EMPLOYMENT_URL = "/company/employment/verify";
export const COMPANY_CONSULTANT_UPDATE_EDUCATION_URL = "/company/consultant/edit/qualification";
export const COMPANY_CONSULTANT_ADD_NEW_EDUCATION_URL = "/company/consultant/add/education";
export const COMPANY_CONSULTANT_DELETE_EDUCATION_URL = "/company/consultant/delete/qualification";
export const COMPANY_CONSULTANT_UPDATE_TRAINING_URL = "/company/consultant/edit/qualification";
export const COMPANY_CONSULTANT_ADD_NEW_TRAINING_URL = "/company/consultant/add/training";
export const COMPANY_CONSULTANT_DELETE_TRAINING_URL = "/company/consultant/delete/qualification";
export const COMPANY_CONSULTANT_DELETE_CERTIFICATION_URL = "/company/consultant/delete/qualification";
export const COMPANY_CONSULTANT_ADD_NEW_CERTIFICATION_URL = "/company/consultant/add/certification";
export const COMPANY_CONSULTANT_UPDATE_CERTIFICATION_URL = "/company/consultant/edit/qualification";
export const COMPANY_INVITE_CONSULTANT_AS_MANAGER_URL = "";
export const COMPANY_REQUEST_MARGER_PROFILE_TO_CONSULTANT_URL = "";
export const COMPANY_ADD_NEW_ASSIGNMENT_URL = "/company/add-assignment";
export const COMPANY_UPDATE_ASSIGNMENT_URL = "/customer/update/lead";
export const COMPANY_ASSING_ASSINGMENT_URL = "/company/consultant/assignment/assign";
export const CONSULTANT_GET_ASSIGNMENT_URL = "/company/get-assignment";
export const CONSULTANT_ACCEPT_ASSIGNMENT_URL = "/notification/assignment/action";
export const CONSULTANT_REJECT_ASSIGNMENT_URL = "/notification/assignment/action";
export const COMPANY_ADD_PROJECT_TO_PUBLIC_URL = "/company/project/add-to-public";
export const COMPANY_SEND_PITCH_URL = "/company/send-pitch";
export const SEARCH_CUSTOMERS_MEMBERS_URL = "/company/search-customers";
export const GET_CUSTOMERS_URL = "/company/get-customers";
export const COMPANY_MERGE_PROFILE_URL = "/company/merge/profile";
export const COMPANY_GET_CONNECTED_SCHOOLS_URL = "/company/get-connected-schools";


// AI Profile
export const AI_WIZARD_SUBMIT_CV_URL = "/account/create-by-cv";
export const GET_SINGLE_PITCH_URL = "/company/get-pitch";
export const CUSTOMER_REJECT_PITCH_URL = "/notification/pitch/action";
export const CUSTOMER_ACCEPT_PITCH_URL = "/notification/pitch/action";
export const CUSTOMER_ADD_PITCH_URL = ""; // -> new
export const COMPANY_ADD_SKILL_URL = "/company/add-skill";
export const COMPANY_SKILL_SAVE_PRIOLITY_URL = "/company/profile/skill/priority";
export const COMPANY_DELETE_SKILL_URL = "/company/profile/skill/delete"
export const COMPANY_EDIT_SKILL_URL = "/company/profile/skill/edit";
export const COMPANY_SEND_PITCH_VIA_EMAIL_URL = "/company/send-email-pitch";
export const SEARCH_COMPANY_OUR_PROJECT_URL = ""; // -> new
export const SEARCH_ASIGNED_ASSIGNMENT_URL = ""; // -> new
export const AI_ACCOUNT_CHANGE_PASSWORD_URL = "/ai/change/password";
export const GET_COMPANY_PROFILE_URL = "/company/get-public-info";
export const MAIN_SEARCH_URL = "/search/get-search-queries";

export const COMPANY_ADD_NEW_CV_URL = "/company/cv/add"
export const COMPANY_APPLY_CV_URL = "/company/cv/apply"
export const GET_USER_COMPANY_CV_URL = "/company/cv/get/custom";
export const COMPANY_DOWNLOAD_CV_URL = "/company/cv/download";
export const COMPANY_UPDATE_CV_URL = "/company/cv/update";
export const COMPANY_REMOVE_CV_URL = "/company/cv/remove";
export const COMPANY_CONSULTANT_SAVE_PRIOLITY_URL = "/company/consultant/prioritize"
export const COMPANY_GET_MY_CV_URL = "/company/cv/get-dir"; // -> New
export const COMPANY_ADD_NEW_CV_FILE_URL = "/company/cv/add/file"; // -> New
export const COMPANY_UPDATE_CV_FILE_URL = "/company/cv/update/file"; // -> New
export const COMPANY_ADD_NEW_FOLDER_URL = "/company/cv/new/folder"; // -> New
export const COMPANY_UPDATE_FOLDER_URL = "/company/cv/update/folder"; // -> New
export const COMPANY_CV_DELETE_FILE_FOLDER_URL = "/company/cv/delete/file-folder"; // -> New
export const COMPANY_DOWNLOAD_CV_FILE_URL = "/company/cv/download/file";
export const COMPANY_GET_COPYIED_PROFILE_URL = "/profile/cv-profile";
export const GET_COMPANY_PROFILE_BASED_ON_MANAGER_URL = "/company/get/based/manager";
export const ACCEPT_MANAGER_INVITATION_URL = "/company/make-admin";
export const COMPANY_CONNECT_WITH_SCHOOL_URL = "/company/connect/school";
export const APPROVE_TO_CONNECT_SCHOOL_URL = "/company/confirm/connect/school";

// School
export const INSTRUCTOR_SUBMIT_ACCOUNT_URL = "/super-manager/school/instructor/activate/account";
export const STUDENT_SUBMIT_ACCOUNT_URL = "/super-manager/school/student/activate/account";
export const GET_SCHOOL_MEMBER_ACCOUNT_INFO_URL = "/super-manager/school/student/get";
export const STUDENT_REJECT_INTERNSHIP_URL = "/super-manager/notification/internship/reject";
export const STUDENT_ACCEPT_INTERNSHIP_URL = "/super-manager/instructor/school/internship/confirm";
export const STUDENT_GET_INTERNSHIP_URL = "/super-manager/instructor/school/student/internship";
export const STUDENT_COMFIRM_MATCH_URL = "/super-manager/instructor/school/student/confirm-match";
export const INSTRUCTOR_SEARCH_INTERNSHIP_URL = "/super-manager/instructor/school/search/internship";
export const INSTRUCTOR_GET_ALL_INTERNSHIP_URL = "/super-manager/internship/get/all";
export const APPLY_INTERNSHIP_URL = "/internship/apply";
export const GET_STUDENT_INSTRUCTOR_INFO_URL = "/super-manager/instructor/info";
export const STUDENT_GET_QUESTIONS_URL = "/super-manager/survey";
export const STUDENT_SUBMIT_ANSWERS_URL = "/super-manager/survey/save/answers";
export const UPLOAD_MILTIPLE_FILE_URL = "/main/upload";

// CUSTOMER - COMPANT
export const CUSTOMER_GET_MY_INTERNSHIPS_URL = "/customer/internships/mine";
export const CUSTOMER_SAVE_INTERNSHIP_URL = "/customer/internships/save";
export const CUSTOMER_UPDATE_INTERNSHIP_URL = "/customer/internships/update";
export const CUSTOMER_SEARCH_MY_INTERNSHIPS_URL = "/customer/internships/search";
export const CUSTOMER_DELETE_INTERNSHIP_URL = "/customer/internships/delete";
export const CUSTOMER_UNPUBLISH_INTERNSHIP_URL = "/customer/internships/unpublish";
export const CUSTOMER_PUBLISH_INTERNSHIP_URL = "/customer/internships/publish";
export const CUSTOMER_GET_PUBLIC_INTERNSHIP_URL = "/customer/internships/published";
export const CUSTOMER_GET_MY_STUDENT_URL = "/customer/students/mine";
export const CUSTOMER_SEARCH_MY_STUDENT_URL = "/customer/students/search";
export const CUSTOMER_SELECT_STUDENT_URL = "/customer/select/student";
export const CUSTOMER_MAKE_STUDENT_INTERN_URL = "/customer/make/student/inter";
export const CUSTOMER_SEND_CONTRACT_URL = "/customer/send/contract";
export const CUSTOMER_MARK_STUDENT_AS_STARTED_URL = "/customer/mark/student/working";
export const CUSTOMER_FILTER_INTERSHIP_URL = "/customer/internships/filter";
export const CUSTOMER_ATTACH_CONTRACT_URL = "/customer/attach/contract";
export const CUSTOMER_REMOVE_CONTRACT_URL = "/customer/remove/contract";
export const INTERNSHIP_GET_SINGLE_URL = "/internship/get/single";
export const PUBLIC_INTERNSHIP_SEARCH_URL = "/super-manager/company/search/public/internship";

export const SCHOOL_DROPDOWN_SEARCH_CLASS_URL = "/school/search/class";
export const SCHOOL_DROPDOWN_ALL_CLASS_URL = "/school/all/class";


// CVS
export const CVS_ADD_NEW_TEMPLATE_URL = "/super-manager/cvs/template/add";
export const CVS_UPDATE_TEMPLATE_URL = "/super-manager/cvs/template/update";
export const CVS_GET_TEMPLATES_URL = "/super-manager/cvs/template/all";
export const CVS_DELETE_TEMPLATE_URL = "/super-manager/cvs/template/delete";
export const CVS_APPLY_TEMPLATE_URL = "/super-manager/cvs/template/apply";
export const CVS_RENAME_TEMPLATE_URL = "/super-manager/cvs/template/rename";
export const CVS_SEARCH_STUDENT_URL = "/super-manager/cvs/search/students";
export const CVS_GET_STUDENT_INFORMATION_URL = "/super-manager/cvs/student/info";
export const CVS_GET_STUDENT_PROJECTS_URL = "/super-manager/cvs/projects";
export const CVS_GET_STUDENT_EMPLOYMENTS_URL = "/super-manager/cvs/employments";
export const CVS_GET_STUDENT_SKILLS_URL = "/super-manager/cvs/skills";
export const CVS_GET_STUDENT_QUALIFICATION_URL = "/super-manager/cvs/qualifications";
export const CVS_UPLOAD_IMAGES_URL = "/super-manager/cvs/upload/images";
export const CVS_ALL_IMAGES_URL = "/super-manager/cvs/images/all";
export const CVS_UPLOAD_BACKGROUND_URL = "/super-manager/cvs/upload/background";
export const CVS_ALL_BACKGROUND_URL = "/super-manager/cvs/background/all";
export const CVS_IMAGE_DELETE_URL = "/super-manager/cvs/image/delete";
export const CVS_SEARCH_PROJECTS_URL = "/super-manager/cvs/search/projects";
export const CVS_SEARCH_EMPLOYMENTS_URL = "/super-manager/cvs/search/employments";
export const CVS_SEARCH_SKILLS_URL = "/super-manager/cvs/search/skills";
export const CVS_SEARCH_QUALIFICATIONS_URL = "/super-manager/cvs/search/qualifications";

export const CVS_SHARE_TEMPLATE_URL = "/super-manager/cvs/template/share";
export const CVS_STOP_SHARE_TEMPLATE_URL = "/super-manager/cvs/template/stop/share";
export const CVS_SUBMIT_CV_URL = "/super-manager/cvs/submit";
export const CVS_GET_CVS_URL = "/super-manager/cvs/get";
export const CVS_UPDATE_CV_URL = "/super-manager/cvs/update";
export const CVS_DELETE_CV_URL = "/super-manager/cvs/delete";
export const CVS_SET_AS_DEFAULT_URL = "/super-manager/cvs/set/default";
export const CVS_GET_TEMPLATE_ITEM_URL = "/cvs/template/item";
export const CVS_ADD_NEW_COMPONENT_URL = "/cvs/template/component/add";
export const CVS_GET_TEMPLATE_COMPONENTS_URL = "/cvs/template/components";
export const CVS_DELETE_TEMPLATE_COMPONENT_URL = "/cvs/template/component/delete";
export const CVS_GENELATE_FILE_URL = "/cvs/generate/file";


export const STUDENT_GET_APPLIED_INTERNSHIP_URL = "/student/internship/applied";
export const STUDENT_RATE_COMPANY_URL = "/student/internship/rate/company";
export const SEARCH_LOCATION_URL = ""
export const STUDENT_UPLOAD_MY_CV_DECISION_URL = "/student/internship/upload/my/cv/decision";


// Notification
export const NOTIFICATION_MARK_ALL_AS_READ_URL = "/notifications/mark/all/read";
export const NOTIFICATION_GET_ALL_URL = "/notifications";


// Lia
export const INTERNSHIP_SAVE_PRIVATE_INTERNSHIP_URL = "/internship/save/private";
export const APPROVE_TO_CONNECT_ACCOUNT_WITH_SCHOOL_URL = "/approve/connect/account/school";
export const RELEASE_NOTES_GET_ACTIVE_URL = "/release/notes/active";

// Matrix
export const GET_ALL_MATRIX_DATA_URL = "/matrix/get/statistics";
export const SEARCH_ALL_MATRIX_USER_URL = "/matrix/search/users";
export const GET_ALL_DEPARTMENT_URL = "/matrix/get/departments";
export const GET_ALL_DEPARTMENT_TEAMS_URL = "/matrix/get/department/teams";
export const GET_ALL_MATRIX_MATCHING_DATA_URL = "/matrix/get/matching/data";
export const MATRIX_START_COMPARE_LEFT_DATA_URL = "/matrix/start/compare/left/data";
export const MATRIX_START_COMPARE_RIGHT_DATA_URL = "/matrix/start/compare/right/data";
export const MATRIX_SEARCH_SKILLS_URL = "/matrix/search/skills";

// Company Lia
export const COMPANY_GET_ALL_PUBLIC_LIA_URL = "/company/get/public/lia";
export const COMPANY_GET_ALL_UNPUBLIC_LIA_URL = "/company/get/unpublic/lia";
export const COMPANY_ADDNEW_LIA_URL = "/company/add/lia";
export const COMPANY_UPDATE_LIA_URL = "/company/update/lia";
export const COMPANY_PUBLISH_INTERNSHIP_URL = "/company/publish/lia";
export const COMPANY_UNPUBLISH_INTERNSHIP_URL = "/company/unpublish/lia";

export const SWITCH_ACCOUNT_URL = "/account/switch";
export const GET_CONNECTED_ACCOUNTS_URL = "/account/get/connected";
export const CONNECT_ACCOUNT_URL = "/account/connect";
export const INITIATE_SWITCH_TO_NORMAL_ACCOUNT_URL = "/account/initiate/switch/normal";
export const COMPLETE_SWITCH_TO_NORMAL_ACCOUNT_URL = "/account/complete/switch/normal";
export const RESEND_VERIFICATION_CODE_URL = "/account/resend/verification/code";